import DefensesSummary from "./DefensesSummary";

export default DefensesSummary;
export { DefensesSummary };
